import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import '@vant/touch-emulator';
import './permission'
import components from "./components"
import { initUrl } from "@/utils/index";
import 'amfe-flexible'
import VueClipboard from "vue-clipboard2";
import globalMethods from '@/utils/global-methods'
Vue.use(globalMethods)
import VueQuillEditor from 'vue-quill-editor'
Vue.use(VueQuillEditor)
initUrl()
Vue.use(VueClipboard);
Vue.use(components);
Vue.use(Vant);
Vue.config.productionTip = false
import "./utils/flexible"
import "@/assets/css/swiper_animate.min.css"
import "@/assets/css/swiper-bundle.min.css"
import "@/assets/css/index.css"
import VConsole from 'vconsole';
const Swiper = require('@/assets/js/swiper-bundle.min.js')
import plugins from './plugins'
Vue.use(plugins)
window.Swiper = Swiper

import "/node_modules/swiper/swiper.scss";
import {
  swiper,
  swiperSlide
} from "vue-awesome-swiper";
Vue.component('swiper', swiper);
Vue.component('swiper-slide', swiperSlide);
import lottie from "vue-lottie";
Vue.component("lottie", lottie);
import './pages/sdkpage/index'

// 注册自定义指令
import maskScroll from './directives/maskScroll'
import dragScroll from './directives/dragScroll'
Vue.directive('mask-scroll', maskScroll)
Vue.directive('drag-scroll', dragScroll)

// if (!location.href.includes('front.3975bbs.com')) {//使用环境变量进行判断
  // const vConsole = new VConsole();
// }
// 正式环境清除所有console.log
if (process.env.NODE_ENV !== 'development') {
  if (window) {
    window.console.log = function () { };
  }
}
Vue.config.ignoredElements = ['wx-open-launch-app']

// PC 端修复：鼠标拖动后避免误触发 click
;(function () {
  if (typeof document === 'undefined') return
  let downX = 0
  let downY = 0
  let dragged = false

  document.addEventListener('mousedown', (e) => {
    downX = e.clientX
    downY = e.clientY
    dragged = false
  }, true)

  document.addEventListener('mousemove', (e) => {
    if (!dragged && (Math.abs(e.clientX - downX) > 5 || Math.abs(e.clientY - downY) > 5)) {
      dragged = true
    }
  }, true)

  document.addEventListener('click', (e) => {
    if (dragged) {
      e.stopPropagation()
      e.preventDefault()
    }
    dragged = false
  }, true)
})()

const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

